/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createLoanScheme,
  fetchLoanSchemes,
  updateLoanScheme,
  deleteLoanScheme,
  resetLoanState,
  createServiceType,
  createService,
  updateService,
} from "../redux/slices/loanSchemeSlice";
import { fetchAllServiceTypes } from "../redux/slices/service_type";
import { toast } from "react-toastify";
import { FaEdit, FaTrash } from "react-icons/fa";
import "../assets/LoanScheme.css";

const roiFrequencies = [
  "Monthly",
  "Quarterly",
  "Half-Yearly",
  "Yearly",
  "Weekly",
  "Daily",
];
const tenureTypes = [
  "Monthly",
  "Quarterly",
  "Half-Yearly",
  "Yearly",
  "Weekly",
  "bi-weekly",
  "Daily",
];
const recoveryFrequencys = [
  "Monthly",
  "Quarterly",
  "Half-Yearly",
  "Yearly",
  "Weekly",
  "bi-weekly",
  "Daily",
];

export default function LoanScheme() {
  const dispatch = useDispatch();
  const { loading, success, error, list } = useSelector(
    (state) => state.loanScheme
  );
  const { allServiceTypes } = useSelector((state) => state.serviceType);

  const [formData, setFormData] = useState({
    serviceType: "",
    serviceTypeId: "",
    serviceName: "",
    minAmount: "",
    maxAmount: "",
    prefix: "",
    maxTenure: "",
    roi: "",
    roiType: "",
    roiFrequency: "",
    minMember: "",
    maxMember: "",
    fixedEmiAmount: "",
    fixedLoanAmount: "",
    fixedLoanTenure: "",
    fixedLoanFrequency: "",
    tenureType: "Months",
    recoveryFrequency: "Monthly",
    active: false,
  });

  const [editId, setEditId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [serviceId, setServiceId] = useState(null);

  useEffect(() => {
    dispatch(fetchAllServiceTypes());
    dispatch(fetchLoanSchemes());
  }, [dispatch]);

  useEffect(() => {
    if (success) toast.success("Loan scheme added successfully.");
    if (error) toast.error("Error: " + error);
    dispatch(resetLoanState());
  }, [success, error, dispatch]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "serviceType") {
      const selected = allServiceTypes.find((stype) => stype.name === value);
      setFormData((prev) => ({
        ...prev,
        serviceType: value,
        serviceTypeId: selected?.id || null,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      serviceName: formData.serviceName,
      serviceType: formData.serviceType,
      serviceTypeId: formData.serviceTypeId,
      minAmount: formData.minAmount || null,
      maxAmount: formData.maxAmount || null,
      maxTenure: formData.maxTenure || null,
      schemeStatus: formData.active ? "Active" : "Inactive",
      isFixedTenure: ["Fixed Loan"].includes(formData.serviceType),
      roi: formData.roi || null,
      roiFrequency: formData.roiFrequency,
      roiType: formData.roiType,
      prefix: formData.prefix,
      fixedEmiAmount: formData.fixedEmiAmount || null,
      fixedLoanAmount: formData.fixedLoanAmount || null,
      fixedLoanTenure: formData.fixedLoanTenure || null,
      fixedLoanFrequency: formData.fixedLoanFrequency || formData.roiFrequency,
      minMember: formData.minMember || null,
      maxMember: formData.maxMember || null,
      tenureType: formData.tenureType || null,
      recoveryFrequency: formData.recoveryFrequency || null,
      superAdminId: localStorage.getItem("adminuserId"),
    };

//     if (editId) {
//       dispatch(updateLoanScheme({ id: editId, data: payload }))
//         .unwrap()
//         .then(() => {
//           toast.success("Loan scheme updated ✅");
//           dispatch(fetchLoanSchemes());

//           if (serviceId) {
//             dispatch(
//               updateService({
//                 id: serviceId,
//                 data: {
//                   name: formData.serviceName,
//                   description: `Service for scheme ${formData.serviceName}`,
//                   superadminId: localStorage.getItem("adminuserId"),
//                   branchId: localStorage.getItem("adminuserId"),
//                   serviceTypeId: formData.serviceTypeId,
//                 },
//               })
//             )
//               .unwrap()
//               .then(() => toast.success("Service updated ✅"))
//               .catch((err) => toast.error("Service update failed: " + err));

//           }
//         });
// }


if (editId) {
  dispatch(updateLoanScheme({ id: editId, data: payload }))
    .unwrap()
    .then(() => {
      toast.success("Loan scheme updated ✅");
      dispatch(fetchLoanSchemes());

      if (serviceId) {
        return dispatch(
          updateService({
            id: serviceId,
            data: {
              name: formData.serviceName,
              description: `Service for scheme ${formData.serviceName}`,
              superadminId: localStorage.getItem("adminuserId"),
              branchId: localStorage.getItem("adminuserId"),
              serviceTypeId: formData.serviceTypeId,
            },
          })
        )
          .unwrap()
          .then(() => {
            toast.success("Service updated ✅");
          })
          .catch((err) => {
            toast.error("Service update failed: " + (err?.message || err));
          });
      }
    })
    .catch((err) => {
      toast.error("Loan scheme update failed ❌: " + (err?.message || err));
    });
}



    else {
      dispatch(createLoanScheme(payload))
        .unwrap()
        .then(() => {
          // toast.success("Loan scheme created ✅");
          dispatch(fetchLoanSchemes());

          dispatch(
            createService({
              name: formData.serviceName,
              description: `Service for scheme ${formData.serviceName}`,
              superadminId: localStorage.getItem("adminuserId"),
              branchId: localStorage.getItem("adminuserId"),
              serviceTypeId: formData.serviceTypeId,
            })
          )
            .unwrap()
            .then((serviceRes) => {
              // toast.success("Service created ✅");

              // Save created service ID
              setServiceId(serviceRes.data.id || serviceRes.id || null);
            })
            .catch((err) => toast.error("Service creation failed: " + err));
        })
        .catch((err) => toast.error("Failed to create loan scheme: " + err));
    }

    // Reset form and IDs
    setFormData({
      serviceType: "",
      serviceName: "",
      serviceTypeId: null,
      minAmount: "",
      maxAmount: "",
      prefix: "",
      maxTenure: "",
      roi: "",
      roiType: "",
      roiFrequency: "",
      minMember: "",
      maxMember: "",
      fixedEmiAmount: "",
      fixedLoanAmount: "",
      fixedLoanTenure: "",
      fixedLoanFrequency: "",
      tenureType: "Months",
      recoveryFrequency: "Monthly",
      active: false,
    });

    setEditId(null);
    setServiceId(null);
  };

  const handleEdit = (loan) => {
    setFormData({
      ...loan,
      active: loan.schemeStatus === "Active",
      serviceType: loan.serviceType || "",
      tenureType: loan.tenureType || "Months",
      recoveryFrequency: loan.recoveryFrequency || "Monthly",
    });

    setServiceId(loan.serviceId || null);

    setEditId(loan.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this loan scheme?")) {
      dispatch(deleteLoanScheme(id)).then(() => dispatch(fetchLoanSchemes()));
    }
  };

  const filteredLoans = useMemo(() => {
    return list.filter(
      (loan) =>
        loan.serviceType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        loan.serviceName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        loan.prefix?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [list, searchTerm]);

  const totalPages = Math.ceil(filteredLoans.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const displayedLoans = filteredLoans.slice(
    startIndex,
    startIndex + entriesPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <div className="LoanSchemeContainer">
      <section className="LoanSchemeForm">
        <h2>Loan Scheme Creation</h2>
        <form onSubmit={handleSubmit}>
          <div className="LoanSchemeGridContainer">
            {/* Service Type */}
            <div>
              <label>Service Type</label>
              <select
                name="serviceType"
                value={formData.serviceType}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Service Type --</option>
                {allServiceTypes.map((stype) => (
                  <option key={stype.id} value={stype.name}>
                    {stype.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Service Name */}
            <div>
              <label>Service Name</label>
              <input
                type="text"
                name="serviceName"
                className="admin-serviceName-input"
                value={formData.serviceName}
                onChange={handleChange}
                required
              />
            </div>

            {/* Conditional Fields */}
            {[
              "Personal Loan",
              "Fixed Loan",
              "Mortgage Loan",
              "CC Loan",
              "Group Loan",
            ].includes(formData.serviceType) && (
              <>
                <div>
                  <label>Min Amount</label>
                  <input
                    type="number"
                    name="minAmount"
                    value={formData.minAmount}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label>Max Amount</label>
                  <input
                    type="number"
                    name="maxAmount"
                    value={formData.maxAmount}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label>Max Tenure</label>
                  <input
                    type="number"
                    name="maxTenure"
                    value={formData.maxTenure}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label>ROI</label>
                  <input
                    type="number"
                    step="0.01"
                    name="roi"
                    value={formData.roi}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label>ROI Type</label>
                  <select
                    name="roiType"
                    value={formData.roiType}
                    onChange={handleChange}
                  >
                    <option value="">Select ROI Type</option>
                    {formData.serviceType==="Fixed Loan"?(
                      <option value="Flat">Flat</option>
                    ):(
                      <><option value="Flat">Flat</option>
                    <option value="Reducing">Reduc ing</option>
                    </>
                    )}
                  </select>
                </div>
                <div>
                  <label>ROI Frequency</label>
                  <select
                    name="roiFrequency"
                    value={formData.roiFrequency}
                    onChange={handleChange}
                  >
                    <option value="">Select Frequency</option>
                    {roiFrequencies.map((freq) => (
                      <option key={freq} value={freq}>
                        {freq}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>Tenure Type</label>
                  <select
                    name="tenureType"
                    value={formData.tenureType}
                    onChange={handleChange}
                  >
                    {tenureTypes.map((freq) => (
                      <option key={freq} value={freq}>
                        {freq}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>Recovery Frequency</label>
                  <select
                    name="recoveryFrequency"
                    value={formData.recoveryFrequency}
                    onChange={handleChange}
                  >
                    {recoveryFrequencys.map((freq) => (
                      <option key={freq} value={freq}>
                        {freq}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>Prefix</label>
                  <input
                    type="text"
                    className="admin-serviceName-input"
                    name="prefix"
                    value={formData.prefix}
                    onChange={handleChange}
                    required
                  />
                </div>
              </>
            )}

            {/* Fixed Loan Fields */}
            {/* {formData.serviceType === "Fixed Loan" && (
              <>
                <div>
                  <label>Fixed Loan Amount</label>
                  <input
                    type="number"
                    name="fixedLoanAmount"
                    value={formData.fixedLoanAmount}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label>Fixed EMI Amount</label>
                  <input
                    type="number"
                    name="fixedEmiAmount"
                    value={formData.fixedEmiAmount}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label>Fixed Loan Tenure</label>
                  <input
                    type="number"
                    name="fixedLoanTenure"
                    value={formData.fixedLoanTenure}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label>Fixed Loan Frequency</label>
                  <select
                    name="fixedLoanFrequency"
                    value={formData.fixedLoanFrequency}
                    onChange={handleChange}
                  >
                    <option value="">Select Frequency</option>
                    {roiFrequencies.map((freq) => (
                      <option key={freq} value={freq}>
                        {freq}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>ROI</label>
                  <input
                    type="number"
                    step="0.01"
                    name="roi"
                    value={formData.roi}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label>ROI Type</label>
                  <select
                    name="roiType"
                    value={formData.roiType}
                    onChange={handleChange}
                  >
                    <option value="">Select ROI Type</option>
                    <option value="Flat">Flat</option>
                    <option value="Reducing">Reducing</option>
                  </select>
                </div>
                <div>
                  <label>ROI Frequency</label>
                  <select
                    name="roiFrequency"
                    value={formData.roiFrequency}
                    onChange={handleChange}
                  >
                    <option value="">Select Frequency</option>
                    {roiFrequencies.map((freq) => (
                      <option key={freq} value={freq}>
                        {freq}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>Tenure Type</label>
                  <select
                    name="tenureType"
                    value={formData.tenureType}
                    onChange={handleChange}
                  >
                    {tenureTypes.map((freq) => (
                      <option key={freq} value={freq}>
                        {freq}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>Recovery Frequency</label>
                  <select
                    name="recoveryFrequency"
                    value={formData.recoveryFrequency}
                    onChange={handleChange}
                  >
                    {roiFrequencies.map((freq) => (
                      <option key={freq} value={freq}>
                        {freq}
                      </option>
                    ))}
                  </select>
                </div>
                <div></div>
                <div>
                  <label>Prefix</label>
                  <input
                    type="text"
                    className="admin-serviceName-input"
                    name="prefix"
                    value={formData.prefix}
                    onChange={handleChange}
                    required
                  />
                </div>
              </>
            )} */}
          </div>

          <div className="LoanSchemeCheckboxContainer">
            <input
              type="checkbox"
              name="active"
              checked={formData.active}
              onChange={handleChange}
            />
            <label>Active</label>
          </div>

          <button type="submit" disabled={loading}>
            {loading
              ? "Submitting..."
              : editId
              ? "Update Loan Scheme"
              : "Add Loan Scheme"}
          </button>
        </form>
      </section>

      {/* Table */}
      <section className="LoanSchemeReportSection">
        <h2 className="loanscheme-table-report-header">Loan Scheme Report</h2>
        <div className="LoanSchemeTableWrapper">
          <table className="LoanSchemeTable">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Service Type</th>
                <th>Service Name</th>
                <th>Min Amount</th>
                <th>Max Amount</th>
                <th>Max Tenure</th>
                <th>Tenure Type</th>
                <th>Recovery Frequency</th>
                <th>Scheme Status</th>
                <th>Is Fixed Tenure</th>
                <th>ROI</th>
                <th>ROI Frequency</th>
                <th>ROI Type</th>
                <th>Prefix</th>
                {/* <th>Fixed EMI Amount</th>
                <th>Fixed Loan Amount</th>
                <th>Fixed Loan Tenure</th>
                <th>Fixed Loan Frequency</th> */}
                {/* <th>Roi</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {displayedLoans.length === 0 ? (
                <tr>
                  <td colSpan="16" style={{ textAlign: "center" }}>
                    No data found
                  </td>
                </tr>
              ) : (
                displayedLoans.map((loan, index) => (
                  <tr key={loan.id}>
                    <td>{startIndex + index + 1}</td>
                    <td>{loan.serviceType||"N/A"}</td>
                    <td>{loan.serviceName||"N/A"}</td>
                    <td>{loan.minAmount||"N/A"}</td>
                    <td>{loan.maxAmount||"N/A"}</td>
                    <td>{loan.maxTenure||"N/A"}</td>
                    <td>{loan.tenureType||"N/A"}</td>
                    <td>{loan.recoveryFrequency||"N/A"}</td>
                    <td>{loan.schemeStatus||"N/A"}</td>
                    <td>{loan.isFixedTenure ? "Yes" : "No"}</td>
                    <td>{loan.roi||"N/A"}</td>
                    <td>{loan.roiFrequency||"N/A"}</td>
                    <td>{loan.roiType||"N/A"}</td>
                    <td>{loan.prefix||"N/A"}</td>
                    {/* <td>{loan.fixedEmiAmount}</td>
                    <td>{loan.fixedLoanAmount}</td>
                    <td>{loan.fixedLoanTenure}</td>
                    <td>{loan.fixedLoanFrequency||"N/A"}</td> */}
                    <td>
                      <button className="LoanSchemeEditBtn" onClick={() => handleEdit(loan)}>
                        <FaEdit />
                      </button>
                      <button className="LoanSchemeDeleteBtn" onClick={() => handleDelete(loan.id)}>
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="LoanSchemePagination">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}